export class FormField {
    public id: number | null;
    public form_id: number;
    public name: string;
    public json_resource_field_id: number | null;

    constructor(data: FormFieldData | void) {
        if (data === undefined) {
            this.id = null;
            this.form_id = -1;
            this.name = "";
            this.json_resource_field_id = null;
        } else {
            this.id = data.id;
            this.form_id = data.form_id;
            this.name = data.name;
            this.json_resource_field_id = data.json_resource_field_id;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.form_id = -1;
        this.name = '';
        this.json_resource_field_id = null;
    }
}

export type FormFieldData = {
    id: number | null;
    form_id: number;
    name: string;
    json_resource_field_id: number | null;
}